const CareersHeroSection = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  return (
  <section>
    <div className="card text-white border-0 hero-card ">
      {/* Responsive image wrapper with fixed height */}
      <div className="card-img-wrapper">
        <img src={`${awsImageBaseUrl}images/PeoplePurposet/people-purpose.jpg`}  className="card-img rounded-0" alt="Hero Background" />
      </div>
      {/* Overlay Content */}
      <div className="card-img-overlay text-center hero-overlay d-flex flex-column">
        <div className="container mt-auto mb-0 mb-lg-2">
          <div className="row justify-content-center">
            <h1 className="font-bold display-6 mb-4 text-shadow col-12 col-md-8">
              <span className="red-bottom-border text-7xl">Join Our Team at Brand Acumen</span>
            </h1>
            <h2 className="font-bold  text-2xl mb-4 text-shadow col-12 col-md-8">
              Shape the future of brand language. Discover challenging and rewarding opportunities.
            </h2>
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};
export default CareersHeroSection;

